

import React, { useState,useEffect } from "react";
import CustomText, { textStyles } from "../../components/CustomText";
import { Box, Modal, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CustomButton from "../../components/CustomButton";
import GetAppButton from "../../components/GetAppButton";
import more from "../../assets/more.svg";
import features3 from "../../assets/features3.svg";
import features10 from "../../assets/features10.svg";
import features11 from "../../assets/features11.svg";
import features13 from "../../assets/features13.svg";
import FeatureCard from "../../components/cards/FeatureCard";

import features1 from "../../assets/features1.svg";
import features2 from "../../assets/features2.svg";

import features4 from "../../assets/features4.svg";
import features5 from "../../assets/features5.svg";
import features6 from "../../assets/features6.svg";
import features7 from "../../assets/features7.svg";
import features8 from "../../assets/features8.svg";
import features9 from "../../assets/features9.svg";


import features12 from "../../assets/features12.svg";

import features14 from "../../assets/features14.svg";
import features15 from "../../assets/features15.svg";
import features16 from "../../assets/features16.svg";
import features17 from "../../assets/features17.svg";

import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BASE_URL } from "../../components/BASE_URL";
import { useSocialLinks } from "../../components/fetchGetAppUrl";
const FeaturesCardsSection = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // e.g. below 600px
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg"));
  
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({});
  const { links, loading } = useSocialLinks();
  const hero_section_button_text = {
    main: "var(--Tertiary, #003149)",
    hover: "#00263a",
    contrastText: "#FFFFFF",
    fontSize: "18px",
  };

    const iconMap = {
  "Clock-In/Out with Location Verification and Facial Recognition": features1,
  "Assign/Self-Assign Tasks with Clock-In/Out, GPS Verification & Facial Recognition": features2,
  "Messaging & Conversations": features5,
  "Smart Notification System": features7,
  "Employee Requests": features6,
  "Documents": features14,
  "Employee Reimbursements & Logs": features4,
  "Employee Payroll Details & History": features8,
  "Employee/Department Productivity & Performance Report": features9,
  "Employee Absence Management with Calendar View": features16,
  "Employee Finances": features11,
  "Employee Loan Management": features12,
  "Subscription & Billing": features17,
  "Applicant Profile": features3,
  "Vendors": features10,
  "Job Openings": features13,
  "Lender Offers": features11,
  "Account Executive": features15,
};

  const comingSoonContent = {
    applicants: {
      icon: <img src={features3} alt="Applicant Profile" draggable={false} onContextMenu={(e) => e.preventDefault()} style={{ pointerEvents: "none" }} />,
      title: t("featuresCards.applicants_title"),
      description: t("featuresCards.applicants_description"),
      additionalInfo: t("featuresCards.applicants_additional_info")
    },
    providers: {
      icon: <img src={features10} alt="Vendors" draggable={false} onContextMenu={(e) => e.preventDefault()} style={{ pointerEvents: "none" }} />,
      title: t("featuresCards.provider_offers_title"),
      description: t("featuresCards.provider_offers_description"),
      additionalInfo: t("featuresCards.providers_additional_info")
    },
    jobs: {
      icon: <img src={features13} alt="Job Openings" draggable={false} onContextMenu={(e) => e.preventDefault()} style={{ pointerEvents: "none" }} />,
      title: t("featuresCards.job_offers_title"),
      description: t("featuresCards.job_offers_description"),
      additionalInfo: t("featuresCards.jobs_additional_info")
    },
    lenders: {
      icon: <img src={features11} alt="Lender Offers" draggable={false} onContextMenu={(e) => e.preventDefault()} style={{ pointerEvents: "none" }} />,
      title: t("featuresCards.lender_offers_title"),
      description: t("featuresCards.lender_offers_description"),
      additionalInfo: t("featuresCards.lenders_additional_info")
    }
  };

  const comingSoonKeyByName = {
  "Applicant Profile": "applicants",
  "Vendors": "providers",
  "Job Openings": "jobs",
  "Lender Offers": "lenders",
};

const defaultModal = {
  icon: null,
  title: t("common.comingSoon"),
  description: "",
  additionalInfo: "",
};

  const handleComingSoonClick = (displayName) => {
  const key = comingSoonKeyByName[displayName];
  const content = key ? comingSoonContent[key] : defaultModal;
  setModalContent(content);
  setModalOpen(true);
};

  const handleCloseModal = () => {
    setModalOpen(false);
    setModalContent({});
  };



  const handleMore = () => {
    navigate("/product-tour");
  };
  const targetLabelMap = {
  "Clock-In/Out with Location Verification and Facial Recognition": "card1",
  "Assign/Self-Assign Tasks with Clock-In/Out, GPS Verification & Facial Recognition": "card2",
  "Messaging & Conversations": "communication",
  "Employee Requests": "alert",
  "Smart Notification System": "multiple roles",
  "Documents": "documents",
  "Employee Reimbursements & Logs": "workers",
  "Employee Payroll Details & History": "simplify",
  "Employee/Department Productivity & Performance Report": "performance",
  "Employee Absence Management with Calendar View": "expenses",
  "Employee Finances": "finances",
  "Employee Loan Management": "attendance",
  "Subscription & Billing": "salaries",
  "Applicant Profile": "applicants",
  "Vendors": "providers",
  "Job Openings": "jobs",
  "Lender Offers": "lenders",
  "Account Executive": "executive",
};

  const getHrefFromLabel = (label) => {
     if (!label) return "#"; 
  const lower = label.toLowerCase().trim();

  // Coming Soon cards - these should not be clickable
  if (lower === "applicants" || lower === "providers" || lower === "jobs" || lower === "lenders") {
    return "#";
  }

  if (lower === "attendance") {
    return "/financial#finance-salary-payroll-logs";

  } else if (lower === "task management") {
    return "/task-management#task-scheduling-tracking";
 
  } else if (lower === "payroll integration") {
    return "/task-management#task-reporting-metrics";
     
  }
   else if (lower === "card1") {
    return "/time-tracking#face-recognition-validation";
  }
   else if (lower === "finances") {
   return "/financial";
  }
   else if (lower === "card2") {
  return"/task-management#card2-task";
  }
   else if (lower === "card3") {
    return "/communication#real-time-insight-card";
  }
  
  else if (lower === "communication") {
    return "/communication#realtime-messaging";
  } 
    else if (lower === "multiple roles") {
    return "/communication#communication-history";
  } 
  
  else if (lower === "face") {
    return "/time-tracking#face-recognition-validation";
  } 
  
  else if (lower === "alert") {
    return "/communication#smart-requests";
  } else if (lower === "simplify") {
    return "/financial#finance-salary-logs";
  } else if (lower === "expenses") {
    return "/task-management#task-map-calendar-integration";
  } else if (lower === "salaries") {
    return "/financial#finance-payment-history";
  } else if (lower === "rules") {
    return "/time-tracking#custom-rules-restrictions";
  } else if (lower === "workers") {
    return "/financial#finance-worker-billing";
  } else if (lower === "documents") {
    return "/communication#real-time-insight-card";
  } else if (lower === "performance") {
    return "/task-management#task-reporting-metrics";
  } else if (lower === "executive") {
    return "/account-executive";
  } else {
    return "#"; // default fallback
  }
};


const [featuresData, setFeaturesData] = useState({
    title: "",
    description: "",
    list: [],
  });

useEffect(() => {
  async function loadFeatures() {
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Home_Features_Website_Cards`
      );
      const json = await res.json();

      const section = (json?.data || []).find(
        (s) => s?.name?.trim().toLowerCase() === "home_features_website_cards"
      );

      if (section?.items?.length) {
        const selectedItem =
          i18n.language === "es"
            ? section.items.find((item) => item.idx === 1)
            : section.items.find((item) => item.idx === 0);

        const parsedList = Array.isArray(selectedItem?.list)
          ? selectedItem.list
          : selectedItem?.list
            ? JSON.parse(selectedItem.list)
            : [];

        setFeaturesData({
          title: selectedItem?.title || "",
          description: selectedItem?.description || "",
          list: parsedList,
        });
      }
    } catch (err) {
      console.error("Error loading features:", err);
    }
  }

  loadFeatures();
}, [i18n.language]);

  return (
    <Box
      sx={{
        paddingTop: isMobile ? "20px" : "40px",
        paddingBottom: "0px",
        position: "relative",
        px: isMobile ? 2 : isTablet ? 2 : 14,
        overflowX: "hidden",  // <-- added line
        width: "100%",
      }}
    >
      <div>
        <CustomText
          style={{
            ...textStyles.h3,

            color: "#072533",
            maxWidth: "900px",
            margin: "0 auto",
            textAlign: "center",
            fontSize: i18n.language === "es" ? "30px" : "48px",
          }}
        >
                {featuresData.title || t("features_heading")}
        </CustomText>
      </div>
      <CustomText
        style={{
          ...textStyles.body2,
          color: "#868282",
          maxWidth: "1050px",
          textAlign: "center",
          margin: "0 auto",
          marginTop: "30px",
        }}
      >

       {featuresData.description || t("features_subtext")}
      </CustomText>
      <Box
        sx={{
          display: "flex",
          flexWrap: isMobile ? "wrap" : "wrap",
          justifyContent: "center",
          gap: "30px",
          marginTop: "40px",
          
        }}
      >
 


        {featuresData.list.map((feature, index) => {
  // const isComingSoon =
  //   !feature.url || ["Applicant Profile", "Vendors", "Job Openings", "Lender Offers"].includes(feature.name);
  const isComingSoon =
    !feature.url ||
    ["Applicant Profile", "Vendors", "Job Openings", "Lender Offers"].includes(feature.name);
  if (isComingSoon) {
    return (
      <div
        key={index}
        style={{
          textDecoration: "none",
          width: isMobile
            ? "100%"
            : isTablet
            ? "calc(50% - 15px)"
            : "calc(33.333% - 20px)",
          boxSizing: "border-box",
          display: "block",
          cursor: "pointer",
          height: "100%",
          position: "relative",
        }}
        // onClick={() => handleComingSoonClick(feature.name.toLowerCase())}
            onClick={() => handleComingSoonClick(feature.name)}
      >
        <FeatureCard
          icon={<img
               crossOrigin="anonymous" 
            src={feature.icon_image_url} alt={feature.name} />}
          title={feature.name}
          description={feature.value}
          variant="light"
          showLearnMore={false}
          isComingSoon={true}
        />
      </div>
    );
  }

  return (
    <div
      key={index}
      onClick={() => navigate(feature.url)} // 🔥 use backend url
      style={{
        textDecoration: "none",
        width: isMobile
          ? "100%"
          : isTablet
          ? "calc(50% - 15px)"
          : "calc(33.333% - 20px)",
        boxSizing: "border-box",
        display: "block",
        cursor: "pointer",
        height: "100%",
      }}
    >
      <FeatureCard
        icon={<img 
             crossOrigin="anonymous"
          
          src={feature.icon_image_url || iconMap[feature.name]} alt={feature.name} />}
        title={feature.name}
        description={feature.value}
        variant="light"
        showLearnMore={true}
      />
    </div>
  );
})}


      </Box>

      <Box
        sx={{
          display: "flex",
          flexWrap: isMobile ? "wrap" : "nowrap",
          justifyContent: "center",
          alignItems: "center",
          mt: isMobile ? 4 : 10,
          gap: 1,
        }}
      >
        <GetAppButton
          label={t("get_app_now")}
          variant="primary"
          size={i18n.language === "es" ? "medium" : "large"}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 0,
      cursor: "pointer",
          }}
          onClick={handleMore}
        >
          <img
            src={more || "/placeholder.svg"}
            alt="Learn More"
            style={{ width: "65px", height: "65px" }}
          />
          <p
            style={{
              color: hero_section_button_text.main,
              fontSize: "18px",
              fontWeight: 600,
              fontFamily: "Poppins, sans-serif",
         
            }}
          >
            {t("Learn More")}
          </p>
        </Box>
      </Box>

      {/* Coming Soon Modal */}
      <Modal
        open={modalOpen}
        onClose={handleCloseModal}
        aria-labelledby="coming-soon-modal-title"
        aria-describedby="coming-soon-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: isMobile ? "90%" : "600px",
            maxHeight: "80vh",
            bgcolor: "background.paper",
            borderRadius: "12px",
            boxShadow: 24,
            p: 4,
            outline: "none",
            overflow: "auto",
          }}
        >
          {/* Close Button */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mb: 2,
            }}
          >
            <IconButton
              onClick={handleCloseModal}
              sx={{
                color: "#666",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Modal Content */}
          {/* Icon */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mb: 3,
            }}
          >
            <Box
              sx={{
                border: "1.8px solid #D1D3D9",
                borderRadius: "10px",
                padding: "16px",
                width: "80px",
                height: "80px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {modalContent.icon}
            </Box>
          </Box>

          {/* Title */}
          <CustomText
            style={{
              fontSize: "32px",
              fontWeight: 700,
              fontFamily: "Poppins, sans-serif",
              color: "#003149",
              textAlign: "center",
              marginBottom: "16px",
              lineHeight: "1.3",
            }}
          >
            {modalContent.title}
          </CustomText>

          {/* Coming Soon Text */}
          <CustomText
            style={{
              fontSize: "20px",
              fontWeight: 600,
              fontFamily: "Poppins, sans-serif",
              color: "#666",
              textAlign: "center",
              marginBottom: "24px",
              lineHeight: "1.3",
            }}
          >
            {t("common.comingSoon")}
          </CustomText>

          <CustomText
            style={{
              fontSize: "18px",
              fontWeight: 500,
              fontFamily: "Nunito, sans-serif",
              color: "#363333",
              textAlign: "center",
              marginBottom: "24px",
              lineHeight: "1.6",
            }}
          >
            {modalContent.description}
          </CustomText>

          <CustomText
            style={{
              fontSize: "16px",
              fontWeight: 400,
              fontFamily: "Nunito, sans-serif",
              color: "#868282",
              textAlign: "left",
              marginBottom: "32px",
              lineHeight: "1.7",
            }}
          >
            {modalContent.additionalInfo}
          </CustomText>

          {/* Close Button */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <CustomButton
              label={t("common.close")}
              onClick={handleCloseModal}
              buttonVariant="secondary"
              size="medium"
            />
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default FeaturesCardsSection;







